import axios from './axios';

export const Logs = {
    getLogs(enquireId) {
        return axios.get(`/ds/logs/enquire/${enquireId}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            }
        })
    },
    createLogs(data, token) {
        return axios.post(
            '/ds/logs',
            data ,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
    }

};
